import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入路由
import VueRouter from 'vue-router'
import router from '@/router'
// 1.导入axios模块
// import axios from 'axios'
// axios.defaults.baseURL = 'http://180.76.246.8:6233/jinnang/'
// Vue.prototype.$http = axios
Vue.config.productionTip = false
//加载插件
Vue.use(ElementUI);
Vue.use(VueRouter)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
